import Link from "next/link";

import { cn } from "@/lib/cn";

/**
 * Tombol — design.md §Components.
 * primary: gradient kinetic, pill. secondary: outline oranye. ghost: teks saja.
 */

type Variant = "primary" | "secondary" | "ghost";
type Size = "md" | "lg";

const VARIANTS: Record<Variant, string> = {
  primary:
    "kinetic-gradient text-white shadow-[0_4px_14px_0_rgb(241,102,6,0.39)] hover:-translate-y-0.5",
  secondary: "border border-primary-container text-primary hover:bg-surface-container-high",
  ghost: "text-primary-container hover:text-primary",
};

const SIZES: Record<Size, string> = {
  md: "px-3.5 py-1.5 text-[12px]",
  lg: "px-5 py-2 text-[13px]",
};

const BASE =
  "inline-flex items-center justify-center gap-2 rounded-full font-bold transition-all duration-200 active:scale-95 disabled:pointer-events-none disabled:opacity-50";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  href?: string;
  full?: boolean;
}

export function Button({
  variant = "primary",
  size = "md",
  href,
  full,
  className,
  children,
  ...props
}: Props) {
  const classes = cn(BASE, VARIANTS[variant], SIZES[size], full && "w-full", className);

  if (href) {
    return (
      <Link href={href} className={classes}>
        {children}
      </Link>
    );
  }

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
}
